import { Component, OnDestroy, OnInit } from "@angular/core";
import { MonitoringTargetsPageViewModel } from "./monitoring-targets.view-model";
import { UserService } from "../../../domain/user-service";
import { ChannelRepository } from "../../../domain/channel-repository";
import { ReportsService } from "../../../services/reports.service";
import { IMonitoringRepository } from "../../../domain/monitoring/monitoring-repository";

@Component({
  selector: "evrideo-targets",
  templateUrl: "./monitoring-targets.component.html",
  styleUrls: ["./monitoring-targets.component.scss"],
})
export class MonitoringTargetsComponent implements OnInit, OnDestroy {
  vm: MonitoringTargetsPageViewModel;
  constructor(
    private _userService: UserService,
    private _channelRepository: ChannelRepository,
    private _reportService: ReportsService,
    private _monitoringRepository: IMonitoringRepository,
  ) {
    console.log(
      "monitoring-targets->constructor",
      MonitoringTargetsPageViewModel.LastState,
    );
  }

  async ngOnInit() {
    if (!MonitoringTargetsPageViewModel.LastState) {
      MonitoringTargetsPageViewModel.LastState =
        new MonitoringTargetsPageViewModel(
          this._userService,
          this._channelRepository,
          this._reportService,
          this._monitoringRepository,
        );
    }

    this.vm = MonitoringTargetsPageViewModel.LastState;

    await this.vm.onInit();
  }

  ngOnDestroy(): void {
    this.vm.onDestroy();
  }
}
